// extracted by mini-css-extract-plugin
export default {"skeletonContent":"skeletonTable_skeletonContent__sVabu","wrapper":"skeletonTable_wrapper__pGn7+"};